import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../../shared/styles/components/Sidebar.css';
import { OvertureLogo } from '../../../shared/assets/images/brand';
import { useDemo } from '../providers/DemoProvider';

const PremiumBadge = () => (
  <span style={{
    background: 'linear-gradient(135deg, #E6B85C, #C48D3A)',
    color: '#4a2c00',
    padding: '3px 8px',
    borderRadius: '8px',
    fontSize: '0.55rem',
    fontWeight: 800,
    marginLeft: 'auto',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
  }}>Premium</span>
);


const DemoSidebar: React.FC = () => {
  const location = useLocation();
  const { showLockedModal } = useDemo();

  const isLinkActive = (path: string) => location.pathname.startsWith(path);

  return (
    <aside 
      className="sidebar" 
      style={{ 
        background: '#4FC3F7', 
        fontFamily: 'Fredoka One, Arial Rounded MT Bold, Arial, sans-serif',
        width: '260px' 
      }}
    >
      <div className="sidebar-logo" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.2rem 0' }}>
        <img src={OvertureLogo} alt="Overture Logo" style={{ height: 60, borderRadius: '1.2rem', background: 'rgba(255,255,255,0.85)', boxShadow: '0 2px 8px rgba(79,195,247,0.10)', padding: '0.2rem 1.2rem', marginBottom: 12 }} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', width: '100%' }}>
          <Link to="/demo/games" className={`sidebar-link ${isLinkActive('/demo/games') ? 'active' : ''}`}>
            <span className="sidebar-icon">🎮</span>Games
          </Link>
           <Link to="/demo/market" className={`sidebar-link ${isLinkActive('/demo/market') ? 'active' : ''}`}>
            <span className="sidebar-icon">🛒</span>Muse Market
          </Link>
          <Link to="/demo/mymuses" className={`sidebar-link ${isLinkActive('/demo/mymuses') ? 'active' : ''}`}>
            <span className="sidebar-icon">🎭</span>My Muses
          </Link>
        </div>
      </div>
      <div className="sidebar-bottom">
        <div className="sidebar-link premium" onClick={showLockedModal} style={{ cursor: 'pointer' }}>
          <span className="sidebar-icon">🧑‍🏫</span>Squads <PremiumBadge />
        </div>
        <div className="sidebar-link premium" onClick={showLockedModal} style={{ cursor: 'pointer' }}>
          <span className="sidebar-icon">🌐</span>Resources <PremiumBadge />
        </div>
        <div className="sidebar-link premium" onClick={showLockedModal} style={{ cursor: 'pointer' }}>
          <span className="sidebar-icon">🎵</span>Songs <PremiumBadge />
        </div>
        <div className="sidebar-link premium" onClick={showLockedModal} style={{ cursor: 'pointer' }}>
          <span className="sidebar-icon">📊</span>Stats <PremiumBadge />
        </div>
      </div>
    </aside>
  );
};

export default DemoSidebar;


